import React from 'react'
import { Route } from '@fs/zion-router'
import useReportsAccess from '../../hooks/useReportsAccess'
import { AuthRouteWrapper } from './AuthRouteWrapper'

const ReportsAuth = ({ component: Component, children, ...rest }) => {
  const { authorized, loading } = useReportsAccess()
  return (
    <Route
      {...rest}
      render={(props) => (
        <AuthRouteWrapper authorized={authorized} loading={loading} redirectTo="/unauthorized" {...rest}>
          {children || <Component {...props} />}
        </AuthRouteWrapper>
      )}
    />
  )
}

export default ReportsAuth
